import type { FunctionComponent, LazyExoticComponent, ReactNode } from 'react'
import { lazy, Suspense } from 'react'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'hooks/rootStore'

type EmptyFunction = () => null

let NewVersionBanner:
  | LazyExoticComponent<() => ReactNode | null>
  | FunctionComponent
  | EmptyFunction = () => null

if (process.env.DEBUG_MODE !== 'true') {
  NewVersionBanner = lazy(() => import('./NewVersionBanner'))
}

export const NewVersionBannerEntry = observer(function NewVersionBannerEntry() {
  const rootStore = useRootStore()
  const route = rootStore.router.currentRoute?.title

  const updatePage = route === 'guidedUpdate'

  if (updatePage) return null
  return (
    <Suspense>
      <NewVersionBanner />
    </Suspense>
  )
})
